module.exports = {"511681001":"双河街道","511681002":"古桥街道","511681003":"华龙街道","511681101":"天池镇","511681102":"禄市镇","511681103":"永兴镇","511681104":"明月镇","511681105":"阳和镇","511681106":"高兴镇","511681107":"观音溪镇","511681108":"溪口镇","511681109":"庆华镇","511681200":"红岩乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511681.json
// module id = 2371
// module chunks = 0